/* RemoveInvalidDevicesComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./RemoveInvalidDevicesRenderer");
// const Registrations = require("../../../../../../RegistrationNamespaces");

class RemoveInvalidDevicesComponent extends EventEmitter {
    constructor(osPlanDetailsViewModel) {
        super();
        this._osPlanDetailsViewModel = osPlanDetailsViewModel;
        this._logger = this._osPlanDetailsViewModel._logger;
        this._gameEditor = this._osPlanDetailsViewModel._gameEditor;
        this._osPlanEntityDef = this._osPlanDetailsViewModel._gameEditor.planEntity;
        this._osPlanEntity = this._osPlanDetailsViewModel._gameEditor.getPlan();
        this._osPlanDeviceUnhealthyCount = this._osPlanEntity.deviceUnhealthyCount || 0;
        this._modalUserFeedback = this._osPlanDetailsViewModel._modalUserFeedback;
        this._userSession = this._osPlanDetailsViewModel._userSession;
        this._activeOrgId = this._userSession.activeOrganization.id;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "RemoveInvalidDevicesComponent.shutdown() error.");
            }
        );
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    removeInvalidDevices(workInput) {
        const {moveToAnotherPlan} = workInput;
        let summaryActionLabel = "remove";

        if (moveToAnotherPlan) {
            summaryActionLabel = "move";
        }

        // Disable the buttons and hide the veil.
        // Once workId is available, switch the screen to results
        // const progressCB = ({workId}) => {};

        if (this._modalUserFeedback) {
            this._modalUserFeedback.displayLoading({message: "Removing invalid devices..."});
        }

        return this._osPlanEntity
            .runRemoveDevicesWork(workInput, {})
            .then((result) => {
                let userNotificationMessage = "";
                let targetCount;
                const title =
                    summaryActionLabel.charAt(0).toUpperCase() +
                    summaryActionLabel.slice(1) +
                    " Completed";

                if (!result.summary) {
                    userNotificationMessage = `Total number of devices ${summaryActionLabel}d: ${
                        result._trimmed.targetResults || 0
                    }`;
                } else {
                    targetCount = result.summary.targetCount;
                    if (result.summary.success) {
                        userNotificationMessage = `The invalid devices were successfully ${
                            summaryActionLabel === "move"
                                ? "moved to the new plan."
                                : "removed from the plan."
                        }`;
                    } else {
                        userNotificationMessage = `The invalid devices were not ${
                            summaryActionLabel === "move"
                                ? "moved to the new plan."
                                : "removed from the plan."
                        }`;
                    }
                }

                if (!targetCount && result.errorMsg) {
                    return Promise.reject({errorMsg: result.errorMsg});
                } else {
                    return this._modalUserFeedback.displayNotification(userNotificationMessage, {
                        title,
                    });
                }
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "RemoveInvalidDevicesComponent.removeInvalidDevices() - Error"
                );
                return this._modalUserFeedback.displayError(err);
            });
    }

    sendResponse(result) {
        this._context.resolve(result);
    }

    cancelAction() {
        this._context.reject({userRejected: true});
    }

    async _generateOsPlanName(name) {
        const baseName = this._removeTrailingInteger(name);
        let existingNames = [baseName];
        let count = 2;
        let newName = baseName;

        const matchingOsPlans = await this._osPlanEntityDef.loadOsUpgradePlans(
            this._activeOrgId,
            {name: {$regex: `^${baseName}-[0-9]+$`}},
            {name: true},
            {name: 1}
        );
        matchingOsPlans.forEach((commandSetEntity) => {
            existingNames.push(commandSetEntity.name);
        });
        while (existingNames.includes(newName)) {
            newName = `${baseName}-${count}`;
            count++;
        }
        return newName;
    }

    _removeTrailingInteger(str) {
        let words = str.split("-");
        if (!isNaN(words[words.length - 1])) {
            words.pop();
        }
        return words.join("-");
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = RemoveInvalidDevicesComponent;
